import DefaultLayout from "@/layouts/DefaultLayout";
import KRegisterForm from "@/components/Auth/KRegister/KRegisterForm";
import logo from "@/assets/logos/logo.png";
import { VImg } from "vuetify/lib";

export default {
	name: "RegisterPage",

	metaInfo: { title: "Request Access" },

	render() {
		return <DefaultLayout maxWidth="400px">
			<VImg
				alt="Kinnect"
				class="mb-3 mx-auto"
				maxHeight={100}
				maxWidth={233}
				src={logo}
			></VImg>

			<KRegisterForm></KRegisterForm>
		</DefaultLayout>;
	}
};
